import {
	TRIGGER_ORDER_CARD_ADDRESS_DETAILS_API,
	TRIGGER_ORDER_CARD_ADDRESS_DETAILS_API_SUCCESS,
} from 'redux/actionTypes';

export function triggerOrderCardAddressDetailsApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_ORDER_CARD_ADDRESS_DETAILS_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerOrderCardAddressDetailsApiCallSuccess(data) {
	return {
		type: TRIGGER_ORDER_CARD_ADDRESS_DETAILS_API_SUCCESS,
		data,
	};
}
